<template>
    <div class="wrap">
        <span v-html="row.model.contact.country_flag"></span>
        {{ row.model.contact.phone_number }}
    </div>
</template>

<script>
  export default {
    props: [
      'row'
    ],
  }
</script>
